<!-- 个人中心 -->
<template>
<!-- 背景色 -->
<div class="body">
  <!-- 个人中心中心会员 -->
  <div :style="{ 'background': 'url(' + require('@/assets/my_bg.png') + ') no-repeat','background-size': '100% 100%'} " class="my_back">
     <div class="contain">
        <van-image round width="1.7rem" height="1.6rem" :src="user.head_img"/>
        <div style=" width:60%;padding-left:20px">
          <div>
            <span style="font-size:16px;color:#fff">{{user.nickname}}</span>
          </div>
          <div style="margin-top:5px">
            <van-button round  plain type="info" size="small" style="background:transparent;color:#fff" >No：{{user.default_card}}</van-button>
          <!-- <van-button round  plain type="info" size="small" style="background:transparent;color:#fff"> 手机号未绑定</van-button> -->
          </div>
        </div>
        <van-image width="0.8rem" height="0.8rem" :src="require('@/assets/er_card2.png')" style="float:right;" />
     </div>
   </div>
    <!-- 余额   积分  推广豆 -->
    <div class="cu_card">
      <van-row >
        <!-- <van-col span="8"><span>油卡</span><div>{{user.card.data.length}}</div></van-col> -->
      </van-row>
    </div>
    <!-- 优惠券等其他列表 -->
    <div class="cu_list">
      <div class="cell">
        <van-image round width="40" height="37" :src="require('@/assets/coupon_my.png')"/>
        <van-cell title="电子券" value="4张" size="large"  to="/dct_my"/>
      </div>
    </div>
    <!-- 发票等申请列表 -->
    <div style="margin-top:20px">
    <div class="cell"><van-image round width="40" height="37" :src="require('@/assets/oilcardbinding_my.png')"/><van-cell title="油卡管理" is-link :to="{path:'card'}"/></div>
    </div>
   <!-- 帮助与反馈 -->
    <div style="margin-top:20px">
      <div class="cell"><van-image round width="40" height="37" :src="require('@/assets/help_my.png')"/><van-cell title="帮助与反馈" is-link /></div>
    </div>
</div>
</template>
<style lang="scss" scoped>
.my_back {
  width: 100%;
  height: 200px;
  position: relative;
  background: #fff;

  .contain {
    width: 95%;
    height: 64px;
    margin:0 auto;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top:40px;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .progress {
    width: 90%;
    position: relative;
    bottom:-138px;
    margin:0 auto;
    text-align: center;
    line-height: 25px;

    .text {
      display: flex;
      justify-content: space-between;
      padding:0 10px
    }
  }

}
.cu_card{
  padding: 10px 5px;
  text-align: center;
  background: #fff;
  line-height: 25px;

    span {
      font-size: 13px;
      color: #888;
    }

    div {
      font-size: 14px;
      color:#0081ff ;
    }
}
  .cu_list {
    margin-top:20px;

    .van-cell__value span {
      display: inline-block;
      color: #f37b1d;
      background-color: #fde6d2;
      padding: 0 10px;
      border-radius: 10px;
    }
  }

  .cell {
     height: 50px;
     display: flex;
     background-color:#fff;
     padding-left:15px;

     .van-image{
       top:7px
     }
  }
</style>
<script>
import { Progress } from 'vant'
export default {
  comments: {Progress},
  data () {
    return {
      data: [],
      user: {}
    }
  },
  created () {
    this.get_user_data()
  },
  methods: {
    // 获取用户数据
    get_user_data () {
      this.ax(this, 'wx_sel_user_info', {}, (res) => {
        if (res.err_num === 0) {
          this.user = res.data
          console.log(this.user.card.data)
        }
      }, false)
    },

    dialog () {
      this.$dialog({
        title: '提示!',
        message: '此功能尚未开通'
      }).then(() => {})
    },

    my_mounted () {
      this.get_data()
    },

    // 获取数据
    get_data () {
      this.get_site_data(this, true, (res) => {
        console.log('站点', res)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/my/my.vue